<template>
  <div>

    <div v-if="showUrl" class="mb-6">
      <a @click="copyToClipboard(url)">{{url}}</a>
    </div>

    <div class="btn-group">

      <tooltip-btn v-slot="{ on }" msg="Copy link to clipboard" top>
        <v-btn v-blur v-on="on" class="btn-group-right px-3" :disabled="_disabled" @click="copyToClipboard(url)">
          <v-icon v-html="mdiClipboardArrowUp" />
        </v-btn>
      </tooltip-btn>

      <v-divider vertical />
      <tooltip-btn v-slot="{ on }" msg="Share link via email" top>
        <v-btn
          v-href-fallback v-on="on"
          class="btn-group-left px-3" v-bind:class="{ 'btn-group-right': IS_MOBILE }"
          :href="email"
          :disabled="_disabled"
        >
          <v-icon v-html="mdiEmail" />
        </v-btn>
      </tooltip-btn>
      
      <template v-if="IS_MOBILE">
        <v-divider vertical />
        <tooltip-btn v-slot="{ on }" msg="Share link via text message" top>
          <v-btn v-href-fallback v-on="on" class="btn-group-left px-3" :href="text" :disabled="_disabled">
            <v-icon v-html="mdiMessage" />
          </v-btn>
        </tooltip-btn>
      </template>

    </div>
  </div>
</template>


<script>
import { orgLink } from '@/mixins/org-link.js';
import { getOrderType } from '@/utils/group-video.js';
import getRecipients from '@/utils/recipients.js';
import { mdiClipboardArrowUp, mdiEmail, mdiMessage, mdiClose } from '@mdi/js';
import moment from 'moment';

export default {
  name: 'share-btn',

  mixins: [ orgLink ],

  props: {
    orderId: String,
    order: Object,
    disabled: Boolean,
    showUrl: Boolean
  },

  data() {
    return {
      url: null,
      buildOrgLinkStatus: this.$track('buildOrgLink')
    };
  },

  computed: {
    _disabled() {
      return !this.orderId || !this.url || this.disabled;
    },

    orderType() {
      return getOrderType(this.order);
    },

    to() {
      const r = getRecipients(this.order);
      return r.length == 1 ? r[0].to : null;
    },

    exp() {
      return moment(this.order.info.send_at).fromNow();
    },

    msg() {
      // Note that you can't really include newlines in this message because they're not properly supported
      // cross-platform - some clients replace '\n' with '<BR>' which unfortunately displays as text
      let msg;
      if ((this.globalUserId == this.order.user_id) && this.order.msg) {
        msg = this.order.msg.replaceAll('\n', ' ');
      } else {
        msg = `We're making a group ${this.orderType}`;
        if (this.to)
          msg += ` for ${this.to}`;
        if (this.order.send_started_at)
          msg += `. It has already been sent, so please add to it as soon as possible.`;
        else if (this.order.info.send_at)
          msg += `. It'll get sent ${this.exp}, so please add to it before then.`;
        else
          msg += `. Please add to it.`;
      }
      return msg + ' ' + this.url;
    },

    email() {
      let subject = `Please add to this group ${this.orderType}`;
      if (this.to)
        subject += ` for ${this.to}`;
      return `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(this.msg)}`;
    },

    text() {
      return `sms:?&body=${encodeURIComponent(this.msg)}`;
    }
  },

  created() {
    Object.assign(this, { mdiClipboardArrowUp, mdiEmail, mdiMessage, mdiClose });
  },

  watch: {
    'order.org_id': {
      immediate: true,
      async handler(v) {
        this.url = null;
        this.url = await this.buildOrgLink('sign/' + this.orderId, v);
      }
    }
  }

}
</script>
